import { defineMessages } from 'react-intl'

export const paymentMethodsPageMessages = defineMessages({
  title: {
    id: 'paymentMethodsPage.title',
    description: 'Title of Payment Methods page',
    defaultMessage: 'Payment Methods',
  },
  addMethod: {
    id: 'paymentMethodsPage.addMethod',
    description: 'Sub-title of Payment Methods page to add payment method',
    defaultMessage: 'Add Payment Method',
  },
})
